import type * as React from 'react';

function SvgCycling(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M4 4h16v16H4z" />
        <path
          d="M17.196 10.998c-.377 0-.75.076-1.096.224a7.19 7.19 0 01-.303-1.823v-1.6h1.649a.601.601 0 010 1.2.4.4 0 100 .8A1.4 1.4 0 0017.445 7h-2.048a.4.4 0 00-.4.4v1.599H9.8v-1.2h1.4A.399.399 0 1011.199 7H8.001a.4.4 0 000 .8h1v1.489l-1.136 1.92a2.799 2.799 0 101.703 2.987h3.23a.438.438 0 00.114-.018l.034-.014a.376.376 0 00.076-.042s.012 0 .018-.01l.022-.02.022-.02a.523.523 0 00.05-.064l1.985-3.358c.07.341.163.678.278 1.007a2.8 2.8 0 101.799-.659zm-7.752-.888l2.54 3.286H9.569a2.798 2.798 0 00-1.015-1.779l.891-1.507zm-2.642 5.685a2 2 0 110-3.998c.222 0 .442.038.651.112l-1 1.683a.401.401 0 10.689.4l.999-1.683a2 2 0 01-1.34 3.486zm5.952-2.71l-2.54-3.287h4.483l-1.943 3.286zm4.442 2.71a1.998 1.998 0 01-1.477-3.34c.29.621.703 1.18 1.21 1.64a.399.399 0 00.667-.323.403.403 0 00-.134-.276 4.422 4.422 0 01-1.082-1.523 2 2 0 11.815 3.822z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgCycling;
